var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagedby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.74355C9.19792 9.74355 8.51132 9.458 7.94021 8.88688C7.36896 8.31563 7.08333 7.62897 7.08333 6.82688C7.08333 6.0248 7.36896 5.3382 7.94021 4.76709C8.51132 4.19584 9.19792 3.91022 10 3.91022C10.8021 3.91022 11.4887 4.19584 12.0598 4.76709C12.631 5.3382 12.9167 6.0248 12.9167 6.82688C12.9167 7.62897 12.631 8.31563 12.0598 8.88688C11.4887 9.458 10.8021 9.74355 10 9.74355ZM3.75 16.0898V14.2371C3.75 13.829 3.86083 13.4511 4.0825 13.1033C4.30417 12.7556 4.60042 12.4882 4.97125 12.3013C5.79486 11.8975 6.62576 11.5947 7.46396 11.3927C8.30215 11.1908 9.1475 11.0898 10 11.0898C10.8525 11.0898 11.6978 11.1908 12.536 11.3927C13.3742 11.5947 14.2051 11.8975 15.0288 12.3013C15.3996 12.4882 15.6958 12.7556 15.9175 13.1033C16.1392 13.4511 16.25 13.829 16.25 14.2371V16.0898H3.75Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedby);
export default __webpack_public_path__ + "static/media/managedby.fc894b1898ac57f5e6ca4d8a95a0233b.svg";
export { ForwardRef as ReactComponent };